import { typedEntries } from '@soundxyz/utils';
import { SplitsFields, splitsState } from './fields';
import { clearSplitsErrors } from './helpers';

export const validateSplits = () => {
  clearSplitsErrors();

  const result = SplitsFields.safeParse(splitsState.fields);

  if (!result.success) {
    // defer so the component picks up the cleared errors and any new ones on rerender
    setTimeout(() => {
      splitsState.errors.splits =
        typedEntries(result.error.flatten().fieldErrors)[0]?.[1]?.[0] ?? null;
      splitsState.isValid = false;
    }, 0);
    return;
  }

  splitsState.isValid = true;
  return result.data;
};
